import { trackingEventNewProjectDialog } from "@buildwithflux/models";
export { trackingEventNewProjectDialog };
/**
 * These are the valid actions for the trackingEventNewProjectDialog event
 *
 * Use e.g. keyof typeof trackingEventActionsForNewProjectDialog when typing against this
 */
export const trackingEventActionsForNewProjectDialog = {
    // Frontend actions
    open: "open",
    close: "close",
    search: "search",
    // snake_case for backwards compatibility on Amplitude graphs :(
    select_template: "select_template",
    new_blank_project: "new_blank_project",
};
//# sourceMappingURL=newProjectDialog.js.map